'use strict';

var en = require('./en');
var de = require('./de');

module.exports = {
    en: en,
    de: de,
};